import { InputNumerico } from "app/components/inputs/InputNumerico";
import clsx from "clsx";
import { useFormik } from "formik";
import React from "react";
import { DadosTabelaProdutosForaEstoque } from "app/types/produto/ProdutoForaEstoque";

const estiloProdutosForaEstoqueSelecionados = require("./produtosForaEstoqueSelecionados.module.scss").default;
const estilosFormulario = require('../../../../estilos/formulario.module.scss').default
const estilosBotoes = require('../../../../estilos/botoes.module.scss').default


export type ProdutosForaEstoqueSelecionadosProps = {
    orcamentoForaModuloVendas: boolean
    processando: boolean
    dadosTabelaProdutosForaEstoque: DadosTabelaProdutosForaEstoque[]
    onAplicar: (dadosTabelaProdutosForaEstoque: DadosTabelaProdutosForaEstoque[]) => void
}


export const ProdutosForaEstoqueSelecionados = (props: ProdutosForaEstoqueSelecionadosProps) => {

    const formik = useFormik({
        initialValues: { dados: props.dadosTabelaProdutosForaEstoque },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });

    return (

        <>
            {formik.values.dados.map((produto, index) => (
                <React.Fragment key={produto.Codigo}>
                    <div className={estiloProdutosForaEstoqueSelecionados.separador} />

                    <div className={`${estilosFormulario.formulario} ${estiloProdutosForaEstoqueSelecionados.formularioProdutosSelecionados}`}>
                        <label>Código</label>
                        <input type="text" name={`dados[${index}].Codigo`} value={(produto?.Codigo) ?? ""} disabled style={{ maxWidth: "100px" }} />
                        <label>Descrição <span className={estilosFormulario.obrigatorio}>*</span></label>
                        <input type="text" name={`dados[${index}].Descricao`} value={(produto?.Descricao) ?? ""} onChange={formik.handleChange} style={{ minWidth: "280px" }} />
                        <label>Preço Unitário <span className={estilosFormulario.obrigatorio}>*</span></label>
                        <InputNumerico
                            onValorModificado={(valor) => {
                                formik.setFieldValue(`dados[${index}].PrecoUnitario`, valor);
                            }}
                            numeroCasasDecimais={2}
                            selecionaValorOnFocus={true}
                            campoNullavel={false}
                            valor={produto?.PrecoUnitario}
                        />
                        <label>Quantidade <span className={estilosFormulario.obrigatorio}>*</span></label>
                        <InputNumerico
                            onValorModificado={(valor) => {
                                formik.setFieldValue(`dados[${index}].Quantidade`, valor);
                            }}
                            numeroCasasDecimais={3}
                            id={`ProdutosForaEstoqueSelecionado_dados[${index}].Quantidade`}
                            selecionaValorOnFocus={true}
                            campoNullavel={false}
                            valor={produto?.Quantidade}
                        />
                    </div>
                    <br />
                </React.Fragment>
            ))}

            {!props.orcamentoForaModuloVendas &&
                <button 
                    className={clsx(estilosBotoes.botaoPrimario, "_mt-3", "_mb-2")} 
                    type="button" 
                    id="ProdutosForaEstoqueSelecionados_btnAplicar"
                    onClick={() => props.onAplicar(formik.values.dados)}
                    disabled={props.processando}
                >
                    Aplicar
                </button>
            }
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
} 